import {BonusType, getBonusGroup} from "../../player/types";
import {put} from "redux-saga/effects";
import {showDialog} from "../actions";
import {INotificationDialogOptions} from "../types";
import {toCssClassName} from "../../../shared/utils/toCssClassName";
import playSound from "../../../shared/sounds/playSound";
import i18n from "../../../shared/i18n";

export function* showBonusAwardDialog({ bonus, count }: { bonus: BonusType, count: number }) {
    let coins, score, bonuses;

    switch (bonus) {
        case BonusType.Coins:
            coins = count;
            playSound("coins-earned");
            break;

        case BonusType.Score:
            score = count;
            playSound("bonus-win");
            break;

        default:
            bonuses = [{
                caption: i18n(`bonuses.${getBonusGroup(bonus)}.${BonusType[bonus].toLowerCase()}.uiname`),
                description: count > 1 ? '×' + count : undefined,
                icon: "bonus_icon_" + toCssClassName(BonusType[bonus])
            }];
            playSound("hint-award");
            break;
    }

    yield put(showDialog({
        type: "NotificationDialog",
        options: {
            title: i18n("bonusaward.header"),
            bonusTitle: "",
            coins,
            score,
            bonuses
        } as INotificationDialogOptions
    }));
}